import { CommonService } from 'src/app/shared/services/common.service';
import { TrnxCommonTs } from './../../shared/common/trnxCommonTs';
import { VaultObjectgroupService } from './vault-objectgroup.service';
import { Actionbutton } from './../../shared/common/Actionbutton';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ReportlinksserviceService } from './../reportlinks/reportlinksservice.service';
import { ErrorMessages } from './../../shared/common/errormessages';
import { constants } from './../../shared/common/contants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportingServiceService } from './../../shared/services/reporting-service.service';
import { validationmethod } from './../../shared/Validations/Validationmethods';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { VaultobjectgroupComponent } from  '../vaultobjectgroup/vaultobjectgroup.component'

@Component({
    selector: 'app-vaultobject-popup-screen',
    templateUrl: './vaultobject-popup-screen.component.html',
    styleUrls: ['./vaultobject-popup-screen.component.scss'],
    standalone: false
})
export class VaultobjectPopupScreenComponent implements OnInit {

 // selectedOptionForRadioBtn: string  =VaultobjectgroupComponent.selectedOptionForRadioBtn

  validations_form: UntypedFormGroup;
  ObjectGrid:any;
  paramstemp;
  ObjectsData:any=[];
  vaultGroup:any=[]
  columnDefsForObjects;
  reportCreationData={"description":"", "groupname":"",objectid: [],"groupType":"Reporting Group"}
  defaultColDef;
  rowSelection;
  allFields: any[];
  selectedFieldsData: any[];
  gridApiForTablesFields;
  selectedObject;
  selectObjectId: any;
  columnDefsForReportingConfiguration: any[];
  tableFields: any[];
  fieldsData: any[];
  tablefields: any;
  gridAPI;
  validation_messages
  // columnDefsForTablesFields;
  ngModelObjectTemporary;
  fieldsDataToRemove: any;
  selectedFieldsDataToPush: any= [];
  temp: any = [];
  selectedTableFields: any;
  gridApi;
  rowbindingdata;
  gridColumnApi;
  getdata: any = []
  backgroundColorScreen="";
  buttonColor="";
  columnDefsForSelectedFields: any;
  rowSelectionForTablesFields;
  components: any;
  isCheckboxSelected: boolean= false;
  // columnDefs;
  value
  retrieveObject: any = [];
  setObject:any=[];
  tableName = "";
  listObjectDropDown: any = [];
  ngModelObject = [];
  updateButton = false;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";

  recordsStart = 0;
  retrieveNgModelCreation: any = [];
  gridColumnAPI;
  selectedObjects: any = [];
  buttonName:any = "Save";
  buttonNameClose;
  hide = false;
  eyeIcon = true;
  nextButton = true;
  parentUpdate;
  formValidCheckbox: UntypedFormGroup;
  formValid: UntypedFormGroup;
  screenTypeTOrM: any;
  nextSaveTOrM = "";
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  editmode;
  update

  // reportCreationDuplicate: any = [];


  constructor(private dialogref: MatDialogRef<VaultobjectPopupScreenComponent>,private validation: validationmethod,private service: ReportingServiceService,private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,private constants: constants,private msg: ErrorMessages,private fb: UntypedFormBuilder,private linkservice: ReportlinksserviceService,private localStorageSettings: LocalStorageSettingsService,private vaultObjectService: VaultObjectgroupService, private trnxCommonTs: TrnxCommonTs,private commonService:CommonService) {
    this.validation_messages = this.msg.reportConfiguration;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      groupname:new UntypedFormControl('',[Validators.required,this.validation.noWhitespaceValidator, this.validation.specialCharacterValidator ]),
      description:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator, this.validation.specialCharacterValidator]),
    });
  }

  formValidationsCheckbox() {

    // form validations
    this.formValidCheckbox = new UntypedFormGroup({
      isCheckboxSelected: new UntypedFormControl("")
    });

  }

  ngOnInit() {
    console.log()
    this.validations_form = this.fb.group({
      groupname: '',
      description: ''
    });

    // While unit testing it is added.
    this.formValidCheckbox = this.fb.group({
      isCheckboxSelected: ''
    });

    // this.lookupVaultGroup();

    this.columnDefsForObjects = [
      {
        headerName: "Vault Objects",
        headerTooltip: "Vault Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName',
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Objects",
        headerTooltip: "Selected  Objects",
        tooltipValueGetter: params => "Selected  Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    // save and update button toggle
    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    console.log(this.buttonName);

    this.formValidationsCheckbox();
    this.formValidation();

    //To different master and transaction screens.
    // if (this.screenTypeTOrM == "Transaction") {

    //   this.nextSaveTOrM = "Next";

    // }

    // else {

    //   this.nextSaveTOrM = "Save";

    // }
    // this.reportCreationDuplicate.push();
  }

  onGridReady(params){
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.linkservice.retrievereportlinks().subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }

 async onGridReadyForObjects(params){
  this.tableFields=[];
  this.selectedObjects=[];
  this.ObjectGrid=params;
  this.spinner.start();
  let tableName="objectmetadata";
  let response=await  this.commonService.retrieveRecordService(tableName);
  this.ObjectGrid.api.setGridOption('rowData', response);
  if(tableName === undefined){
        this.ObjectGrid.api.setGridOption('rowData', []);
      }else{
      this.tablefields = response;
      console.log(this.tablefields)
      this.gridApiForTablesFields = params;
      this.ObjectGrid.api.setGridOption('rowData', this.tablefields);
      }
      this.gridApiForTablesFields = params.api;

}



  onRowSelected(event) {

    this.fieldsData = this.ObjectGrid.api.getSelectedRows();

    this.selectedObjects = this.fieldsData;

    console.log(this.selectedObjects);
}

  onGridReadyForSelectedTableFields(params,data) {
    this.selectedTableFields=params
    this.selectedFieldsDataToPush=data;
    // console.log(this.selectedFieldsDataToPush);
    //this.gridApiForTablesFields = params.api;
    console.log(data);
    console.log(this.selectedTableFields)

    this.selectedTableFields.api.setGridOption('rowData', data);
    //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }

   //forward Icon Function decleation
   pushDataToSelectedFieldsGrid() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.selectedObjects,'selected objects');
    for (let i = 0; i < this.selectedObjects.length; i++) {
     this.reportCreationData.objectid.push({objectid:this.selectedObjects[i].id})
    }
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedObjects.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
        console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);

  }

  //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.selectedObjects)
    console.log(this.tablefields);
  //  this.selectedTableFields = this.tableFields
    for (let i = 0; i < this.tablefields.length; i++) {
      this.reportCreationData.objectid.push({objectid:this.tablefields[i].id})
     }
    // //duplicates data not allowed
   this.temp = this.tablefields.filter(obj => !uniq[obj.objectlabel] && (uniq[obj.objectlabel] = true));
        console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.pushDataToSelectedFieldsGrid();
    this.ObjectGrid.api.forEachNode(node=>{

      node.setSelected(true)

})
  }

  //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedObjects = []
    this.temp = []
    this.reportCreationData.objectid=[]
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,null)
    // this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.ObjectGrid.api.forEachNode(node=>{

      node.setSelected(false)

})
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    for(let o=0;o<this.fieldsDataToRemove.length;o++){
      this.ObjectGrid.api.forEachNode(node=>{
        if(node.data.objectlabel===this.fieldsDataToRemove[o].objectlabel){
             node.setSelected(false)
        }
      })
    }
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }



  save(){
    console.log("======================99999999==========")
    console.log(this.selectedFieldsDataToPush);
    console.log(this.isCheckboxSelected);
  console.log(this.reportCreationData);
  this.spinner.start();
    this.vaultObjectService.insertMstrObjectGroup(this.reportCreationData).subscribe(response => {
      // this.spinner.start();
       console.log(response)
        // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,

        });
        this.spinner.stop();
      }
      else if(this.isCheckboxSelected == true)
      {
        this.reportCreationData.objectid = [];
        this.validations_form.reset();
        this.formValidCheckbox.reset();
        this.ObjectGrid.api.deselectAll();
        this.selectedObjects=[];
        this.selectedTableFields.api.setGridOption('rowData', []);
        // this.ObjectGrid.api.setGridOption('rowData', []);
        let tableName="objectsmetadatamstr";
        let response=  this.commonService.retrieveRecordService(tableName);
        this.snackbar.open('Object Group created successfully', "OK", {
          duration: 5000,
        });
        this.ObjectGrid.api.setRowData.reset();
        if(tableName === undefined){
            this.ObjectGrid.api.setRowData.reset();
          }else{
          this.tablefields = response;
          console.log(this.tablefields)
          this.ObjectGrid.api.setRowData.reset();
          this.selectedObjects.api.setRowData.reset();
          }
          // this.gridApiForTablesFields.setRowData.reset();
          // this.fieldsData = this.ObjectGrid.api.getSelectedRows.reset();
          // this.selectedObjects = this.fieldsData;
      }
       else {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        // window.location.reload();
        // this.dialogref.close();
        // this.cancel();
      }
      // this.spinner.stop();
      // this.onGridReady(this.rowbindingdata);

      console.log(this.isCheckboxSelected);
      // this.isCheckboxSelected = true;
      // if (this.isCheckboxSelected == true){
      //   this.validations_form.reset();
      //   this.formValidCheckbox.reset();
      // }
      // else{
      //   this.dialogref.close();
      //   this.cancel();
      //   // this.reportCreationDuplicate.push(response);
      //   // this.spinner.start();
      // }
      this.spinner.stop();

    });
  // this.cancel();
  }


  // async next(value) {
  //   console.log(value)
  //   // checking the form is valid or not while insert
  //   if (!this.formValid.valid) {

  //     // displaying validation messages

  //     this.validation.validateAllFormFields(this.formValid);

  //     this.validation.getvalidationmessage();

  //   }
  // }

  close(){
    console.log(this.isCheckboxSelected);
    console.log(typeof this.isCheckboxSelected);
    //It will execute if checkbox is not selected.
    if (this.isCheckboxSelected == false) {

      //It will reset checkbox form.
      this.validations_form.reset();
      this.formValidCheckbox.reset();

      //It will call checkbox formValidationCheckbox method.
      this.formValidationsCheckbox();

      // this.reportCreationData = [];

      this.dialogref.close();

    }
  }
  cancel() {
  // this.formValidCheckbox.reset();
  // this.formValidationsCheckbox();
  this.isCheckboxSelected = false;
   this.reportCreationData= {
    description: "",
    groupname: "",
   objectid: [],
   groupType:"",
   }
   this.dialogref.close();

   this.close();
   window.location.reload();
  }

}
